const tones = {
  neutral:  'bg-white border border-line text-ink',
  actif:    'bg-actif-bg text-actif-fg',
  passif:   'bg-passif-bg text-passif-fg',
  fiscal:   'bg-fiscal-bg text-fiscal-fg',
  objectif: 'bg-objectif-bg text-objectif-fg',
  essentiel:'bg-fiscal-bg text-fiscal-fg font-semibold',
}

export default function Chip({ tone = 'neutral', className = '', children }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] tracking-[.3px] ${tones[tone]} ${className}`}>
      {children}
    </span>
  )
}
